import { useAuth } from "../contexts/AuthContext";
import { LangSwitch } from "./LangSwitch";
import { parseView } from "../lib/retail";

export function Header() {
  const { me, t, setShowAdmin, setAdminInitialTab, view, retail } = useAuth();
  if (!me) return null;

  let displayName = me.display_name ?? me.name;
  let subtitle = "";
  const roleLabel = (role: string) => (role === "admin" ? t("role_admin") : t("role_pk"));

  if (me.is_admin) {
    const v = parseView(view);
    if (v.kind === "all") { displayName = t("header_owner_all"); subtitle = t("header_owner_mode"); }
    else if (v.kind === "store") {
      displayName = retail?.stores.find(s => s.store === v.store)?.label ?? v.store;
      subtitle = t("header_store_mode");
    } else {
      const row = retail?.rows.find(r => r.person_id === v.personId);
      displayName = row?.display_name ?? v.personId;
      subtitle = row ? `${row.store_label} · ${roleLabel(row.role)}` : "";
    }
  } else {
    const v = parseView(view);
    if (v.kind === "store" && me.view_store === v.store) {
      displayName = retail?.stores.find(s => s.store === v.store)?.label ?? v.store;
      subtitle = t("header_store_admin");
    } else {
      const row = retail?.rows[0];
      if (row) subtitle = `${row.store_label} · ${roleLabel(row.role)}`;
    }
  }

  const maintenanceOn = me.is_admin && me.maintenance_mode === true;
  return (
    <header className="bg-gradient-to-br from-teal-600 to-emerald-600 text-white pt-12 flex-shrink-0">
      <div className="px-5 pb-3 flex items-center justify-between gap-2">
        <div className="flex-1 min-w-0">
          <div className="text-xs opacity-80">{t("app_title")}</div>
          <div className="text-lg font-semibold truncate">{displayName}</div>
          {subtitle && <div className="text-[11px] opacity-80 truncate">{subtitle}</div>}
        </div>
        {me.is_admin && (
          <button
            onClick={() => setShowAdmin(true)}
            className="bg-white/15 hover:bg-white/25 text-white text-xs font-semibold rounded-full px-3 py-1.5 transition"
          >{t("admin_button")}</button>
        )}
        <LangSwitch />
      </div>
      {maintenanceOn && (
        <button
          onClick={() => { setAdminInitialTab("settings"); setShowAdmin(true); }}
          className="w-full bg-amber-400 hover:bg-amber-300 text-amber-950 text-xs font-semibold py-1.5 px-5 flex items-center justify-center gap-2 transition"
        >
          <span>🔧</span>
          <span>{t("header_maintenance_on")}</span>
          <span className="opacity-70">·</span>
          <span className="opacity-80">{t("header_maintenance_tap")}</span>
        </button>
      )}
    </header>
  );
}
